import React from 'react';
import { Grid } from '@mui/material';
import { Colors, Text } from 'library';
import StripeIcon from 'assets/icons/tandempay/stripe_slate.svg';
import VisaIcon from 'assets/icons/tandempay/Visa_2021.svg';

export default function PaymentPartners() {
    return (
        <Grid item direction="column" alignItems="center">
            <Grid item>
                <Text variant="body3" color={Colors.mediumGrey}>
                    Our payment partners
                </Text>
            </Grid>
            <Grid
                container
                item
                direction="row"
                justifyContent="space-around"
                alignContent="center"
                alignItems="center"
            >
                <Grid item>
                    <StripeIcon style={styles.icon} />
                </Grid>
                <Grid container item xs={2} style={styles.visaContainer}>
                    <VisaIcon style={styles.icon} />
                </Grid>
            </Grid>
        </Grid>
    );
}

const styles = {
    icon: { width: 48, maxHeight: 48 },
    visaContainer: {
        height: 32,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        maxWidth: 48,
    },
};
